import Theme from '../theme'


class BuilderTheme extends Theme {
    constructor(){
      super()
      this.font = "Noto Sans"
      this.sizes.normal = "17px"
      this.sizes.normalSmall = "14px"
    }
  
    get defaultFont(){
      return `${super.defaultFont}font-weight: 400;`
    }
  
    get Title(){
      return this.styled(super.Title)` font-weight: bold;`
    }
  }
  
  

  export default BuilderTheme;